module.exports = __webpack_public_path__ + "static/MLB-Logotype-748fb964d79a7519c84482f1dd7b646a.svg";